export const VOTEKICK_ELEMENT_KIND = "votekick.tally" as const;
